import actions from './actions';
import mutations from './mutations';
import { mutationTypes, actionTypes } from '@/types';
import { setSubPartStateFromLocalstorage } from './setSubPartStateFromLocalstorage';

export default {
	state: {
		isSyncerApp: false,
		mode: null,
		subPartStates: {},
		offlineAvailablePackages: [],
		offlineAvailablePackagesIndex: new Set(),
		packagesProcessed: 0,
		packagesTotal: 0,
		errors: [],
		activeSubPartId: null,
	},
	getters: {
		progress(state) {
			return state.packagesTotal > 0
				? Math.round((100 * state.packagesProcessed) / state.packagesTotal)
				: undefined;
		},
	},
	mutations,
	actions,
	plugins: [
		store => {
			store.subscribe(mutation => {
				if (mutation.type === mutationTypes.setLanguage) {
					setSubPartStateFromLocalstorage({ getters: store.getters, commit: store.commit });
				}
			});
			// Inform webview about sync progress
			window.nativeOnAppOfflineAppSyncProgress = (appsProcessed, appsTotal, error) => {
				store.commit(mutationTypes.packageSyncerSetProgress, { appsProcessed, appsTotal, error });
				if (error !== null && typeof error === 'string' && error !== 'null') {
					store.commit(mutationTypes.packageSyncerPushError, {
						message: error,
						activeSubPartId: store.state.packageSyncer.activeSubPartId,
					});
				}
				if (appsProcessed === appsTotal) store.dispatch(actionTypes.packageSyncerStopped);
			};
		},
	],
};
